import { useTranslation } from 'react-i18next';
import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons/faWandMagicSparkles';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { Button, ButtonType } from '../../../../Button';

type Props = {
  handlePostAJob(): void;
}

export const JobPostsNullState = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const { handlePostAJob } = props;

  return (
    <WidgetCard
      iconName={faWandMagicSparkles}
      iconClasses='text-tansy'
      title={t('dashboard.widgets.myJobPosts.title')}
      description={t('dashboard.widgets.myJobPosts.description')}
      hasButton
      buttonComponent={<Button
          buttonType={ButtonType.primary}
          onClick={handlePostAJob}>{t('dashboard.widgets.myJobPosts.postAJob')}
        </Button>
      }
    />
  );
};
